module.exports = __webpack_public_path__ + "static/media/singer-img.ec9a1944.png";